module.exports = __webpack_public_path__ + "img/checked.2cfd8abd.svg";